// Typelizer digest d1b6fce02cde9ad754bd39b87cf55994
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/counterparties/:counterparty_id/settlement_sales */
  update: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/settlement_sales', params, options),
    method: 'patch',
  }),
}
